import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Coverage } from "risa-data-model";

import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";

interface CovergaeDetails {
  data?: Coverage[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: CovergaeDetails = {
  data: null,
  loading: false,
  error: null,
};

const allCoveragesForOrderSlice = createSlice({
  name: "allCoveragesForOrderSlice",
  initialState,
  reducers: {
    fetchAllCoverageStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAllCoverageSuccess(state, action: PayloadAction<Coverage[]>) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAllCoverageFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    resetAllCoverage(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchAllCoverageStart,
  fetchAllCoverageSuccess,
  fetchAllCoverageFailure,
  resetAllCoverage,
} = allCoveragesForOrderSlice.actions;

export const fetchAllCoverageForAnOrder =
  (orderId: string) => async (dispatch) => {
    dispatch(fetchAllCoverageStart());
    const unsubscribe = FirestoreService.listenToAllDocuments<Coverage>(
      FirestoreCollectionReference.coverage(orderId),
      (coverage) => {
        dispatch(fetchAllCoverageSuccess(coverage));
      },
      (error) => {
        dispatch(fetchAllCoverageFailure(error.message));
      },
    );

    return unsubscribe;
  };

export default allCoveragesForOrderSlice.reducer;
